module.exports = __webpack_public_path__ + "static/hero-image-85d62ab30ffff9afb855fb8b0ba4e8ba.jpg";